import { IconDefinition } from "@fortawesome/fontawesome-common-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  children: React.ReactNode
  icon?: IconDefinition
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export default function ChipButton({ children, icon, onClick }: Props) {
  return (
    <button type="button" className="chip-button" onClick={onClick}>
      {icon && <FontAwesomeIcon icon={icon} />}
      <span>{children}</span>
    </button>
  )
}
